// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.5 2C8.46243 2 6 4.46243 6 7.5C6 10.5376 8.46243 13 11.5 13C14.5376 13 17 10.5376 17 7.5C17 4.46243 14.5376 2 11.5 2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 14C17.0694 14 16.5 14.6561 16.5 15.2489V16.2489H14.5V15.2489C14.5 13.3576 16.1692 12 18 12C19.8308 12 21.5 13.3576 21.5 15.2489C21.5 16.1644 21.0933 16.9746 20.4733 17.549L19 18.9388V19.6223H17V18.0759L19.1123 16.0834C19.3677 15.8476 19.5 15.5523 19.5 15.2489C19.5 14.6561 18.9306 14 18 14Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9991 20.9961H19.003V23H16.9991V20.9961Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.8762 14C12.0139 15.103 11.5 16.4915 11.5 18C11.5 19.5085 12.0139 20.897 12.8762 22H2V20C2 16.6863 4.68629 14 8 14H12.8762Z"}}]};

const UserUnknownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'user-unknown-filled',
    ref,
    icon: element,
  },
));

UserUnknownFilledIcon.displayName = 'UserUnknownFilledIcon';

export default UserUnknownFilledIcon;
